import { useSearchParams } from "react-router-dom";
import { Radar, Users, GitBranch } from "lucide-react";
import { AutoChase } from "@/components/communications/AutoChase";
import { EmployeeDirectory } from "@/components/communications/EmployeeDirectory";
import { Strategies } from "@/components/communications/Strategies";

const TABS = [
  { key: "chases", label: "Auto-chase", icon: Radar },
  { key: "employees", label: "Employees", icon: Users },
  { key: "strategies", label: "Strategies", icon: GitBranch },
];

const resolveTab = (sp) => {
  const t = sp.get("tab");
  if (t && TABS.some((x) => x.key === t)) return t;
  if (sp.get("flag") || sp.get("sort")) return "employees";
  return "chases";
};

export default function Communications() {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = resolveTab(searchParams);
  const setTab = (key) => setSearchParams(key === "chases" ? {} : { tab: key }, { replace: true });

  return (
    <div className="space-y-4" data-testid="communications-page">
      <div className="flex flex-wrap items-center gap-1" data-testid="communications-tabs">
        {TABS.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)} data-testid={`communications-tab-${t.key}`}
            className={`flex items-center gap-1.5 whitespace-nowrap rounded-xl px-3 py-1.5 text-[12.5px] transition-colors ${
              tab === t.key ? "bg-[#1f1f1f] text-white" : "text-[#A3A3A3] hover:text-white"
            }`}>
            <t.icon size={13} /> {t.label}
          </button>
        ))}
      </div>

      {tab === "chases" ? <AutoChase /> : tab === "employees" ? <EmployeeDirectory /> : <Strategies />}
    </div>
  );
}
